import type {
  ProfileRepositoryBootstrap,
  ProfileRepositorySession
} from "@/features/navigation";

export function createStableProfileRepositoryBootstrap(
  source: ProfileRepositoryBootstrap
): ProfileRepositoryBootstrap {
  let sessionPromise: Promise<ProfileRepositorySession> | null = null;

  return () => {
    if (sessionPromise !== null) {
      return sessionPromise;
    }

    const attempt = Promise.resolve().then(source);
    sessionPromise = attempt;
    void attempt.catch(() => {
      if (sessionPromise === attempt) {
        sessionPromise = null;
      }
    });

    return attempt;
  };
}
